

import React, { useState } from 'react';

// Sample Data
const teachersData = [
  { id: 1, name: 'Alice', subject: 'Math', country: 'USA', rate: 50 },
  { id: 2, name: 'Bob', subject: 'Physics', country: 'Canada', rate: 45 },
  { id: 3, name: 'Charlie', subject: 'Math', country: 'Canada', rate: 40 },
  { id: 4, name: 'Diana', subject: 'English', country: 'Uganda', rate: 50 },
  { id: 5, name: 'Lutalo', subject: 'Math', country: 'USA', rate: 56 },
  { id: 6, name: 'Bosa', subject: 'Physics', country: 'Uganda', rate: 45 },
  { id: 7, name: 'sserunkuuma', subject: 'Math', country: 'Canada', rate: 42 },
  { id: 8, name: 'Gotto', subject: 'English', country: 'South Africa', rate: 35 },
];

const TutorFinder = () => {
  const [subject, setSubject] = useState('All');
  const [country, setCountry] = useState('All');

  // Get unique subjects and countries for dropdowns
  const subjects = ['All', ...new Set(teachersData.map((t) => t.subject))];
  const countries = ['All', ...new Set(teachersData.map((t) => t.country))];

  // Filtering Logic
  const filteredTeachers = teachersData.filter(
    (t) =>
      (subject === 'All' || t.subject === subject) &&
      (country === 'All' || t.country === country)
  );

  return (
    <div className="p-10 bg-gray-50 min-h-screen top-30">
      <h1 className="text-2xl font-bold mt-10 text-gray-800">Find a Tutor</h1>
      
      {/* Filters */}
      <div className="flex gap-4 mb-6">
        <select onChange={(e) => setSubject(e.target.value)} className="p-2 border rounded">
          {subjects.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <select onChange={(e) => setCountry(e.target.value)} className="p-2 border rounded">
          {countries.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      {/* Teacher Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {filteredTeachers.map((t) => (
          <div key={t.id} className="p-4 bg-white shadow rounded-lg border">
            <h2 className="text-xl font-semibold">{t.name}</h2>
            <p className="text-gray-600">{t.subject} - {t.country}</p>
            <p className="text-blue-600 font-bold">${t.rate}/hr</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TutorFinder;



